module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_lounge_pass.8961c9a7.png";